import type { EntityOptions } from 'models';
import { Button, Icon } from 'ui';
import { useGetPathToAdminEntitiesList } from './hooks';

export type AdminExtractedEntityType = Extract<
  EntityOptions['entityType'],
  'community' | 'giving' | 'organization' | 'program'
>;

type P = {
  entityType: AdminExtractedEntityType;
};

const AdminConsoleButton = ({ entityType }: P) => {
  const getPathToAdminEntitiesList = useGetPathToAdminEntitiesList();

  return (
    <Button
      icon={<Icon icon="user-security-line" />}
      navigate={{ external: true, to: getPathToAdminEntitiesList(entityType) }}
      target="_blank"
    >
      View in Admin Console
    </Button>
  );
};

export default AdminConsoleButton;
